<template>
  <div class="main-container">
    <base-jin-nang-panel title="收费申请">
      <template v-slot:bodyContent>
        <el-form :model="applyForm" class="apply-form">
          <div class="form-row mb30">
            <div class="row-label">申请类型</div>
            <div class="row-input">
              开通
            </div>
          </div>
          <div class="form-row mb30">
            <div class="row-label">价格</div>
            <div class="row-input">
              <el-select
                v-model="applyForm.price"
                class="width366"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in priceList"
                  :key="item.index"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="form-row mb30">
            <div class="row-label">更新频次</div>
            <div class="row-input">
              <el-select
                v-model="applyForm.numsPerDay"
                class="width366"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in countList"
                  :key="item.index"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="form-row mb20">
            <div class="row-label">申请理由:</div>
            <div class="row-input">
              <el-input
                type="textarea"
                placeholder="请填写申请理由"
                v-model="applyForm.reason"
                maxlength="30"
                show-word-limit
                class="remark"
                rows="6"
              >
              </el-input>
            </div>
          </div>
          <div class="form-row mb40">
            <div class="row-label"></div>
            <div class="row-input agreement">
              <div
                :class="{
                  icon: true,
                  select: isAgree
                }"
                @click="agreementToggle"
              ></div>
              <div>
                我已阅读并同意<router-link class="protocol" to=""
                  >《付费点金开通协议》</router-link
                >
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="row-label"></div>
            <div class="row-input">
              <el-button
                :class="{
                  subBtn: true
                }"
                @click="applyDianJin"
                type="button"
                >提交</el-button
              >
            </div>
          </div>
        </el-form>
      </template>
    </base-jin-nang-panel>
  </div>
</template>

<script>
import BaseJinNangPanel from '../BaseJinnangPanel/BaseJinNangPanel'
import { feeApply } from '@/api/dianjin'
export default {
  name: 'Pament',
  components: { BaseJinNangPanel },
  data() {
    return {
      applyForm: {
        price: 258,
        numsPerDay: 2,
        reason: '',
        chargeApplyType: 1
      },
      isAgree: false,
      priceList: [
        { text: '258元/月', value: 258, index: 0 },
        { text: '328元/月', value: 328, index: 1 },
        { text: '388元/月', value: 388, index: 2 },
        { text: '488元/月', value: 488, index: 3 },
        { text: '588元/月', value: 588, index: 4 },
        { text: '688元/月', value: 688, index: 5 }
      ],
      countList: [
        { text: '2次/日', value: 2, index: 0 },
        { text: '3次/日', value: 3, index: 1 },
        { text: '4次/日', value: 4, index: 2 }
      ]
    }
  },
  methods: {
    async applyDianJin() {
      if (!this.formvalidate()) {
        return
      }
      const data = await feeApply({
        ...this.applyForm
      })
      if (data && data.result.code === 0) {
        this.$router.push('/excl-author/dianjin/payment/apply-result')
      } else {
        this.$message.error(data.result.msg || '申请失败')
      }
    },
    formvalidate() {
      if (!this.applyForm.price) {
        this.$message.error('请选择价格')
        return false
      } else if (!this.applyForm.numsPerDay) {
        this.$message.error('请选择更新频次')
        return false
      } else if (!this.applyForm.reason) {
        this.$message.error('请填写申请理由')
        return false
      } else if (!this.isAgree) {
        this.$message.error('您必须先同意《付费点金开通协议》')
        return false
      } else {
        return true
      }
    },
    agreementToggle() {
      this.isAgree = !this.isAgree
    }
  },
  created() {}
}
</script>

<style scoped>
.main-container {
  border-radius: 5px;
  background-color: #ffffff;
}

.apply-form {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.form-row {
  display: flex;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
}
.row-label {
  text-align: center;
  line-height: 44px;
  letter-spacing: 0px;
  color: #858585;
  margin-right: 20px;
  width: 135px;
  flex: none;
}

.row-input {
  flex: auto;
  line-height: 44px;
}

.width366 {
  width: 366px;
}

.mb30 {
  margin-bottom: 30px;
}
.mt20 {
  margin-top: 20px;
}
.mb40 {
  margin-bottom: 40px;
}

.mb10 {
  margin-bottom: 10px;
}

.width200 {
  width: 200px;
}
.bgfa {
  background-color: #fafafa;
}

.style-container {
  width: 430px;
  flex: none;
  display: flex;
  flex-flow: row wrap;
  padding: 8px 0px 30px 30px;
}

.remark {
  width: 366px;
}

.style-cell {
  margin-top: 18px;
  width: 140px;
}

.subBtn {
  width: 180px;
  height: 44px;
  background-color: #046bcc;
  border-radius: 5px;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
  margin-bottom: 55px;
}
.agreement {
  color: #858585;
}
.icon {
  width: 20px;
  height: 20px;
  border-radius: 20px;
  margin-right: 10px;
  cursor: pointer;
  background-image: url('~@/assets/images/icons/unsel2x.png');
  background-size: 20px;
}

.icon.select {
  background-image: url('~@/assets/images/icons/sel2x.png');
  background-size: 20px;
}

.protocol {
  color: #046bcc;
  text-decoration: underline;
}
.agreement {
  display: flex;
  align-items: center;
}
</style>
